<!--add_48dp_FILL0_wght400_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px">
    <path d="M450-450H200v-60h250v-250h60v250h250v60H510v250h-60v-250Z"/>
  </svg>
</template>
